const INVITES = {
  INVITE_SENT: 'Connection invite sent.',
  CONNECTION_REQUEST_SENT: 'Connection request sent.',
  REFER_A_BUSINESS: 'Refer a Business',
  SENT: 'Connection request sent.',
  NOT_FOUND: 'Connection request not found',
  NOT_FOUND_OR_ACCEPTED: 'Connection request not found or already accepted.',
  EXISTS: 'Connection request already exists or invalid.',
  CONNECTION_EXISTS: 'Users already connected.',
  DELETED: 'Connection request deleted.',
  INVALID: 'Invalid connection request.',
  ACCEPTED: 'Connection request accepted.',
  CONNECTION_CREATED: 'Connection created.',
  STATUS_CHANGED: 'Status updated.',
  INVALID_USER:
    'Cannot send connection request to this user. Please reach out to Perkforce or send feedback for help.',
  REFERRAL_SENT: 'Referral sent.',
} as const;

export default INVITES;
